var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0505 11.47L13.0505 4.47C12.8575 4.28243 12.5792 4.21204 12.3203 4.28533C12.0614 4.35863 11.8613 4.56447 11.7953 4.82533C11.7293 5.08619 11.8075 5.36243 12.0005 5.55L17.7105 11.25H4.48047C4.06626 11.25 3.73047 11.5858 3.73047 12C3.73047 12.4142 4.06626 12.75 4.48047 12.75H17.7005L12.0005 18.45C11.8575 18.5893 11.7769 18.7804 11.7769 18.98C11.7769 19.1796 11.8575 19.3707 12.0005 19.51C12.1383 19.6546 12.3307 19.7345 12.5305 19.73C12.7295 19.7309 12.9206 19.6516 13.0605 19.51L20.0605 12.51C20.3529 12.2172 20.3529 11.7428 20.0605 11.45L20.0505 11.47Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.456860d9355201c518765b30a72d78ae.svg";
export { ForwardRef as ReactComponent };